import React,{useState} from 'react';
import { BASE_URL } from '../utils/config';
import ReactSelect from 'react-select'
import { Dialog} from '@mui/material';

const DeliverySection = ({ stockSymbols,DeliveryIntraDayChecked,NSEStockSymbols,BSEStockSymbols,requestToken,commenteryData,isEditable, onDeliverySectionChange,onDeliveryStockSelect,onRemoveFile,generateImage}) => {
  


  const [deliverySectionState, setDeliverySectionState] = useState({
    deliveryReportType:'BUY',
    tradingsymbol:"NSE",
    stockType: '',
    deliveryCmp:'',
    FirstTarget:'',
    stockIncToken:"",
    deliveryRemark1: '',
    deliveryRemark2: '',
    deliverySL:'',
    commentry:'',
    chartImageInterval:'1D',
    Signal:'Buy'
  });

  let RemarkText = 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
  const nseoptions = NSEStockSymbols.map((data) => ({
    ...data,
    value: data.name,
    label: data.name,
  }));

  const bseoptions = BSEStockSymbols.map((data) => ({
    ...data,
    value: data.name,
    label: data.name,
  }));

  const CommenteryData = commenteryData.map((data)=>({
   ...data,
   value: data.Description,
   label: data.CommentaryName,
  }))
  const customStyles = {
    // Define your custom styles here
    menu: (provided) => ({
      ...provided,
      width: '256px',
      marginLeft:'185px'
    }),
    control: (provided, state) => ({
      ...provided,
      width: '256px', // Set the desired width for the entire component
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : null,
      '&:hover': {
        border: '1px solid #2684FF',
      },
    }),
    // Add more styles for other elements as needed
  };
  const [cmperror,setCmpError]=useState(false)
  const [firsttargeterror,setFirstTargetError]=useState(false)
  const [slerror,setSlError]=useState(false)
 
  const[CmpErrorMsz,setCmpErrorMsz]=useState('')
  const[showCmpApiError,setShowCmpApiError]=useState(false)
  const [showAlert, setshowAlert] = useState(false);
  const [AlertMessage, setAlertMessage] = useState("");
  
// handle input change
  const handleInputChange = (event) => {
    setCmpError(false);
    setSlError(false)
    const { name, value } = event.target;
    if (/^\d*\.?\d{0,2}$/.test(value)) {
    setDeliverySectionState((prevState) => {
      
      let  newState 
      if(name === 'deliverySL' && value == '0'){
        
        newState = {
          ...prevState,
          [name]: value,
          deliveryRemark1:RemarkText
        };
      }
      else if(name === 'deliverySL' && value != '0'){
        
        newState = {
          ...prevState,
          [name]: value,
          deliveryRemark1:""
        };
      }
      else{
        newState = {
          ...prevState,
          [name]: value,
          
        };
      }
  
     
     onDeliverySectionChange(newState);
  
      return newState;
    });
  } else {
    if(name === 'deliveryCmp'){
     setCmpError(true)
     setTimeout(() => {
      setCmpError(false)
    }, 2000);
    }
    if(name==='deliverySL'){
      setSlError(true)
      setTimeout(() => {
        setSlError(false)
      }, 2000);
    }
    if(name==='FirstTarget'){
      setFirstTargetError(true)
      setTimeout(() => {
        setFirstTargetError(false)
      }, 2000);
    }
  };



  
  
   
  };

  // handle stock change
  const handleStockChange = (event)=>{
    // const { name, value } = event.target;
  
    setDeliverySectionState((prevState) => {
      const newState = {
        ...prevState,
        stockType: event.value,
        deliveryCmp:"",
        deliveryRemark1:"",
        deliveryRemark2:"",
        deliverySL:'',
        commentry:"",
        Signal:"Buy"

      };

      onRemoveFile();

     
  
      let selectedStockRecord
      if(deliverySectionState.tradingsymbol === 'NSE'){
        selectedStockRecord = NSEStockSymbols.find(item => item.name === event.value);
      }
      else{
      selectedStockRecord = BSEStockSymbols.find(item => item.name === event.value);
    }
      // console.log("selectedStockRecord",selectedStockRecord)
    generateImage(selectedStockRecord.tradingsymbol,selectedStockRecord.segment,deliverySectionState.chartImageInterval)
      onDeliveryStockSelect(selectedStockRecord);
      onDeliverySectionChange(newState);
    
      return newState;
    });

    fetchCMPfromStockChange(event.value)
  }

  // handle change radio button and select for SignalType

  const handleChange = (event) => {
 
    const { name, value } = event.target;
     
    if(name === 'tradingsymbol'){
      setDeliverySectionState((prevState) => {
        const newState = {
          ...prevState,
          [name]: value,
          stockType: '',
          deliveryCmp:'',
          FirstTarget:'',
          stockIncToken:"",
          deliveryRemark1: '',
          deliveryRemark2: '',
          deliverySL:'',
          commentry:'',
          chartImageInterval:'1D',
          Signal:'Buy'
        };
    
        
        onDeliverySectionChange(newState);
    
        return newState;
      })
    }else{
    setDeliverySectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };
  
      
      onDeliverySectionChange(newState);
  
      return newState;
    })
    }
  
  };
  
// handle chart interval change
  const handleChartinterval = (event) => {

    const { name, value } = event.target;
     if (!deliverySectionState.stockType || !deliverySectionState.tradingsymbol) {
    console.log("Stock symbol not available. Skipping interval change.");
    setAlertMessage(`Please Select Stock Name and Trading Type First then try to change the Image Interaval.`);
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('')
      }, 3000);
    return;
  }
    setDeliverySectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };

      // Log the updated state
      // console.log("OptionSectionState", newState);

      // Notify the parent component about the change
      onDeliverySectionChange(newState);

      let selectedStockRecord
      if(deliverySectionState.tradingsymbol === 'NSE'){
        selectedStockRecord = NSEStockSymbols.find(item => item.name === deliverySectionState.stockType);
      }
      else{
      selectedStockRecord = BSEStockSymbols.find(item => item.name === deliverySectionState.stockType);
    }
      // console.log("selectedStockRecord",selectedStockRecord)
    generateImage(selectedStockRecord.tradingsymbol,selectedStockRecord.segment,value)

      return newState;
    });



  };

   
// handle commentary change
  const handleOptionChange = (event) => {
    
    const { name, value } = event.target;
 
  
    setDeliverySectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };
  
      onDeliverySectionChange(newState);
   
      return newState;
    });
  
  }

  // handle api to fetch cmp price
  const fetchCMP = async (e) => {
    e.preventDefault();
    let StockName;
    if (deliverySectionState.tradingsymbol === 'NSE') {
      StockName = NSEStockSymbols.find(item => item.name === deliverySectionState.stockType);
    } else {
      StockName = BSEStockSymbols.find(item => item.name === deliverySectionState.stockType);
    }

    if (!StockName || !StockName.instrument_token) {
      setCmpErrorMsz('Stock Instrument Token not found for the selected stock');
      setShowCmpApiError(true);
      setTimeout(() => {
        setShowCmpApiError(false);
        setCmpErrorMsz('');
      }, 2000);
      return;
    }

    await fetch(`${BASE_URL}/getcmpprice/${StockName.instrument_token}/Delivery/expiry`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        if (res.success === true) {
          let Stock_IncToken = res.stock_IncToken;
          let last_price = res.instruments.last_price;

          setDeliverySectionState((prevState) => {
            const newState = {
              ...prevState,
              deliveryCmp: last_price,
              stockIncToken: Stock_IncToken
            };

            onDeliverySectionChange(newState);
            return newState;
          });
        } else {
          setCmpErrorMsz(`Error: ${res.message}`);
          setShowCmpApiError(true);
          setDeliverySectionState((prevState) => {
            const newState = {
              ...prevState,
              deliveryCmp: "",
              stockIncToken: ""
            };

            onDeliverySectionChange(newState);
            return newState;
          });

          setTimeout(() => {
            setShowCmpApiError(false);
            setCmpErrorMsz('');
          }, 1000);
        }
      })
      .catch(error => {
        setCmpErrorMsz(`Error: ${error.message}`);
        setShowCmpApiError(true);
        setDeliverySectionState((prevState) => {
          const newState = {
            ...prevState,
            deliveryCmp: "",
            stockIncToken: ""
          };

          onDeliverySectionChange(newState);
          return newState;
        });
        setTimeout(() => {
          setShowCmpApiError(false);
          setCmpErrorMsz('');
        }, 1000);
        console.error('Error fetching data:', error);
      });
  };

  // handle api to fetch cmp price
  const fetchCMPfromStockChange = async(value) => {
    let StockName;
    if (deliverySectionState.tradingsymbol === 'NSE') {
      StockName = NSEStockSymbols.find(item => item.name === value);
    } else {
      StockName = BSEStockSymbols.find(item => item.name === value);
    }

    if (!StockName.instrument_token) {
      setCmpErrorMsz('Stock Instrument Token not found for the given value');
      setShowCmpApiError(true);
      setTimeout(() => {
        setShowCmpApiError(false);
        setCmpErrorMsz('');
      }, 2000);
      console.error('Stock not found for the given value:', value);
      return;
    }

    console.log("StockName", StockName);
    await fetch(`${BASE_URL}/getcmpprice/${StockName.instrument_token}/Delivery/expiry`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(response => response.json())
      .then(res => {
        if (res.success === true) {
          let Stock_IncToken = res.stock_IncToken;
          let last_price = res.instruments.last_price;

          setDeliverySectionState((prevState) => {
            const newState = {
              ...prevState,
              deliveryCmp: last_price,
              stockIncToken: Stock_IncToken
            };

            onDeliverySectionChange(newState);
            return newState;
          });
        } else {
          setCmpErrorMsz(`Error: ${res.message}`);
          setShowCmpApiError(true);
          setDeliverySectionState((prevState) => {
            const newState = {
              ...prevState,
              deliveryCmp: "",
              stockIncToken: ""
            };

            onDeliverySectionChange(newState);
            return newState;
          });

          setTimeout(() => {
            setShowCmpApiError(false);
            setCmpErrorMsz('');
          }, 1000);
        }
      })
      .catch(error => {
        setCmpErrorMsz(`Error: ${error.message}`);
        setShowCmpApiError(true);
        setDeliverySectionState((prevState) => {
          const newState = {
            ...prevState,
            deliveryCmp: "",
            stockIncToken: ""
          };

          onDeliverySectionChange(newState);
          return newState;
        });
        setTimeout(() => {
          setShowCmpApiError(false);
          setCmpErrorMsz('');
        }, 1000);
        console.error('Error fetching data:', error);
      });
  }

  return (
    <div className="deliverymain">
      <div id="btndeliveryreportDiv" className="btndeliveryreportdiv">
        <p>BUY</p>
        <input type="radio" value="BUY" defaultChecked name="buy" onChange={handleChange} />
        {/* <button type="button" onclick="submitForm()">Submit</button> */}
      </div>

       <div id="btndeliveryreportDiv" className="btndeliveryreportdiv">
        <p>NSE</p>
        <input type="radio" value="NSE" defaultChecked name="tradingsymbol" onChange={handleChange} />
        <p>BSE</p>
        <input type="radio" value="BSE" name="tradingsymbol" onChange={handleChange} />

      </div>

      <div className="deliverycontent">
      <div>
          <p>Chart-Image Interval:</p>
          <select value={deliverySectionState.chartImageInterval} id="chartImageInterval" name="chartImageInterval" onChange={handleChartinterval}>
  <option value="4h">4h</option>
  <option value="1D">1D</option>
  <option value="1W">1W</option>
  <option value="1M">1M</option>
  <option value="1Y">1Y</option>
</select>
        </div>
        <div>
          <p>Stock Name:<span className='asterisk'>*</span></p>
          {deliverySectionState.tradingsymbol === 'NSE'?
          // <select id="DeliveryStocktype" name="stockType" required onChange={handleStockChange}>
          // <option value="">Select Stock</option>
          // {console.log("NSEStockSymbols",NSEStockSymbols)}
          //   {NSEStockSymbols.map((symbol) => (
          //     <option key={symbol.name} value={symbol.name}>
          //       {symbol.name}
          //     </option>
          //   ))}
          // </select>
          <ReactSelect
          id="DeliveryStocktype" 
          name="stockType"
          options={nseoptions}
          onChange={handleStockChange}
          styles={customStyles}
          disabled={!isEditable}
          />
          :null}
          {deliverySectionState.tradingsymbol === 'BSE'?
          // <select id="DeliveryStocktype" name="stockType" required onChange={handleStockChange}>
          // <option value="">Select Stock</option>
          // {console.log("BSEStockSymbols",BSEStockSymbols)}
          //   {BSEStockSymbols.map((symbol) => (
          //     <option key={symbol.name} value={symbol.name}>
          //       {symbol.name}
          //     </option>
          //   ))}
          // </select>
          <ReactSelect
          id="DeliveryStocktype" 
          name="stockType"
          options={bseoptions}
          onChange={handleStockChange}
          styles={customStyles}
          disabled={!isEditable}
          />
           :null}
        </div>

      

        <div style={{marginTop:'16px'}}>
          <p>Signal:<span className='asterisk'>*</span></p>
          <select id="Signal" name="Signal" value={deliverySectionState.Signal} onChange={handleChange}  disabled={!isEditable}>
            <option value="">Select signal</option>
            <option value="Buy">Buy</option>
            <option value="Buy & Accumulate">Buy & Accumulate</option>
            <option value="Buy & Others">Buy & Others</option>
          </select>
        </div>


        {cmperror?<span style={{color:'red',fontSize:'15px'}}>Numeric input with 2 decimal places (0-9).</span>:null}
        
{showCmpApiError?<span style={{color:'red',fontSize:'15px'}}>{CmpErrorMsz}</span>:null}
        <div>
          <p>CMP :<span className='asterisk'>*</span></p>
          <button class="fetch" style={{cursor: deliverySectionState.stockType == '' ?'not-allowed':'pointer'}} disabled={deliverySectionState.stockType == ''} onClick={fetchCMP}>Fetch</button>
          <input value={deliverySectionState.deliveryCmp} type="number" id="deliveryCmp" name="deliveryCmp" required  onChange={handleInputChange}  disabled={!isEditable}/>
        </div>

        {firsttargeterror?<span style={{color:'red',fontSize:'15px'}}>Numeric input with 2 decimal places (0-9).</span>:null}
        
        {DeliveryIntraDayChecked
          ?( <div>
            <p>First Target :<span className='asterisk'>*</span></p>
          
            <input value={deliverySectionState.FirstTarget} type="number" id="FirstTarget" name="FirstTarget" required  onChange={handleInputChange}  disabled={!isEditable}/>
          </div>):null
        }
        
        {slerror?<span style={{color:'red'}}>Numeric input with 2 decimal places (0-9).</span>:null}
        <div>
          <p>SL :</p>
          
          <input value={deliverySectionState.deliverySL} type="number" id="deliverySL" name="deliverySL" required  onChange={handleInputChange}  disabled={!isEditable}/>
        </div>

        <div>
          <p>Select commentary:<span className='asterisk'>*</span></p>
          <select value={deliverySectionState.commentry} id="selectcommentry" name="commentry" required onChange={handleOptionChange}  disabled={!isEditable}>
            <option value="">Select commentary</option>
            {commenteryData.map((data) => (
                      <option key={data.CommentaryName} value={data.Description}>
                        {data.CommentaryName}
                      </option>
                    ))}
          </select>
        
        </div>


        <div>
          <p>
           Commentary Remarks:
          </p>
          {/* <input type="textarea" id="deliveryremark" name="deliveryRemark" required  onChange={handleInputChange}/> */}
          <textarea
          style={{
            border: `2px solid ${deliverySectionState.deliverySL === '0' ? 'red' : 'rgba(0, 0, 0, 0.2)'}`,
            outline: 'none',
          }}
          value={deliverySectionState.deliveryRemark1}
    id="deliveryRemark1"
    name="deliveryRemark1"
    required
    rows={4}
    onChange={handleChange}
    disabled={!isEditable}
  />
        </div>
        <div>
          <p>
           Remarks:
          </p>
          {/* <input type="textarea" id="deliveryremark" name="deliveryRemark" required  onChange={handleInputChange}/> */}
          <textarea
          value={deliverySectionState.deliveryRemark2}
    id="deliveryRemark2"
    name="deliveryRemark2"
    required
    rows={4} 
    onChange={handleChange}
    disabled={!isEditable}
  />
        </div>

     
      </div>
       
            <Dialog
                                 open={showAlert}
                                 onClose={() => { setshowAlert(false) }}
                                 aria-labelledby="alert-dialog-title"
                                 aria-describedby="alert-dialog-description"
                               >
                                 <p style={{ color: "green", padding: '10px 30px 10px 30px', margin: 0 }}>{AlertMessage}</p>
                               </Dialog>
    </div>
  );
};

export default DeliverySection;
